import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons'; 
import Editor from "@monaco-editor/react";

const ShowDbConnection = ({ isModalVisible, handleOk, handleCancel,connectionText , theme}) => {
  const [copied, setCopied] = useState(false);
  
  function handleCopy(codeToCopy) {
    navigator.clipboard.writeText(codeToCopy).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    });
    
}
  return (
    
    <Modal
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[]}
      className='custom-modal'
      destroyOnClose={true}
      centered 
    >

      <div className="mt-4">
        <Tooltip title={copied ? "Copied" : "Copy"}>
            <span
                onClick={() => {
                    handleCopy(connectionText);
                }}
                style={{ cursor: 'pointer', float: 'right', marginBottom: '10px' }}>
                <CopyOutlined />&nbsp;Copy
            </span>
        </Tooltip>
        <Editor
            defaultLanguage={"python"}
            height={"160px"}
            theme={theme}
            defaultValue={connectionText}
            options={{ readOnly: true }}
        />
       
      </div>

    </Modal>
  );
};

export default ShowDbConnection;
